import { render } from "./MessageTemplate.vue?vue&type=template&id=2502e62a&scoped=true&ts=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts"

import "./MessageTemplate.vue?vue&type=style&index=0&id=2502e62a&scoped=true&lang=less"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2502e62a"]])

export default __exports__